import noDataDialog from "./noDataDialog";
export default noDataDialog;


// WEBPACK FOOTER //
// ./src/myMixin/noDataDialog/index.js